import React, { Component } from "react";
import { Row, Col } from "../../../../common/grid";
import MdEdit from "react-icons/lib/md/edit";
import MdDelete from "react-icons/lib/md/delete";
import MdFileDownload from "react-icons/lib/md/file-download";
import { connect } from "react-redux";
import { fetchLetters, deleteLetter } from "../../../../actions/letter.js";
import {
	fetchLetterTemplates,
	deleteLetterTemplate
} from "../../../../actions/letter-template.js";
import RenderIfUserHas from "../../../../common/roles/RenderIfUserHas.js";
import BrowserHistory from "../../../../providers/BrowserHistory.js";
import Button from "../../../../common/button/Button.js";
import Modal from "../../../../common/modal/Modal.js";
import Tabs from "../../../../common/tabs/Tabs.js";

import "./LettersIndex.css";

class LettersIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			confirmed: false,
			letterId: null,
			letterTemplateId: null,
			selectedTab: "SENT"
		};

		this.onAddNewBoxClick = this.onAddNewBoxClick.bind(this);
		this.onAddNewTemplateBoxClick = this.onAddNewTemplateBoxClick.bind(this);
		this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
		this.onTabClick = this.onTabClick.bind(this);
	}

	onAddNewBoxClick() {
		BrowserHistory.push("/main/letters/add");
	}

	onAddNewTemplateBoxClick() {
		BrowserHistory.push("/main/letter-templates/add");
	}

	onDeleteClick(letterId, e) {
		e.stopPropagation();
		this.setState({ showModal: true, letterId });
	}

	onDeleteTemplateClick(letterTemplateId, e) {
		e.stopPropagation();
		this.setState({ showModal: true, letterTemplateId });
	}

	onDeleteConfirm() {
		this.setState({ showModal: false, confirm: true });
		if (this.state.letterId) {
			this.props.deleteLetter(this.state.letterId);
		}

		if (this.state.letterTemplateId) {
			this.props.deleteLetterTemplate(this.state.letterTemplateId);
		}
	}

	onEditClick(letterId, e) {
		e.stopPropagation();
		BrowserHistory.push(`/main/letters/${letterId}/edit`);
	}

	onEditTemplateClick(letterTemplateId, e) {
		e.stopPropagation();
		BrowserHistory.push(`/main/letter-templates/${letterTemplateId}/edit`);
	}

	onTabClick(tabName) {
		this.setState({ selectedTab: tabName });
	}

	componentDidMount() {
		this.props.fetchLetters();
		setTimeout(this.props.fetchLetterTemplates, 1000);
	}

	renderLetter(l) {
		return (
			<Row key={l.id}>
				<div className="box" onClick={this.onEditClick.bind(this, l.id)}>
					<h3 className="name">{l.recipient}</h3>
					<span className="created_at">
						<strong>Created at:</strong> {l.created_at}
					</span>
					<span className="action_date">
						<strong>{l.type === "sent" ? "Sent at" : "Received at"}:</strong>{" "}
						{l.date_of_action}
					</span>
					<span className="author">
						<strong>Uploaded by:</strong> {l.user.first_name} {l.user.last_name}
					</span>
					<span className="sender">
						<strong>Sender:</strong> {l.sender}
					</span>
					<span className="recipient">
						<strong>Recipient:</strong> {l.recipient}
					</span>
					<div className="buttons">
						<a className="btn-blue download-btn" href={l.file_url}>
							<MdFileDownload />
						</a>
						<RenderIfUserHas roles={["admin"]}>
							<Button
								className="btn-blue"
								onClick={this.onEditClick.bind(this, l.id)}
							>
								<MdEdit />
							</Button>
							<Button
								className="btn-red"
								onClick={this.onDeleteClick.bind(this, l.id)}
							>
								<MdDelete />
							</Button>
						</RenderIfUserHas>
					</div>
				</div>
			</Row>
		);
	}

	renderLetterTemplate(lt) {
		return (
			<Row key={lt.id}>
				<div className="box" onClick={this.onEditClick.bind(this, lt.id)}>
					<h3 className="name">{lt.name}</h3>
					<span className="created_at">
						<strong>Created at:</strong> {lt.created_at}
					</span>
					<div className="buttons">
						<a className="btn-blue download-btn" href={lt.file_url}>
							<MdFileDownload />
						</a>
						<RenderIfUserHas roles={["admin"]}>
							<Button
								className="btn-blue"
								onClick={this.onEditTemplateClick.bind(this, lt.id)}
							>
								<MdEdit />
							</Button>
							<Button
								className="btn-red"
								onClick={this.onDeleteTemplateClick.bind(this, lt.id)}
							>
								<MdDelete />
							</Button>
						</RenderIfUserHas>
					</div>
				</div>
			</Row>
		);
	}

	render() {
		if (!this.props.letters || !this.props.letterTemplates) {
			return null;
		}

		// filter by tabs
		let content = this.props.letters;
		if (this.state.selectedTab === "SENT") {
			content = this.props.letters.filter(l => l.type === "sent");
		} else if (this.state.selectedTab === "RECEIVED") {
			content = this.props.letters.filter(l => l.type === "received");
		} else if (this.state.selectedTab === "TEMPLATES") {
			content = this.props.letterTemplates;
		}

		return (
			<Col _bottom-24 letters-index>
				<h2>Manage Letters</h2>
				{this.state.showModal && (
					<Modal
						type="CONFIRMATION"
						onConfirm={this.onDeleteConfirm}
						onCancel={() =>
							this.setState({
								confirm: false,
								showModal: false,
								letterId: null,
								letterTemplateId: null
							})
						}
						show={this.state.showModal}
					>
						Are you sure?
					</Modal>
				)}
				<RenderIfUserHas roles={["admin"]}>
					<Row _right-16 _wrap>
						<div className="addNewBox" onClick={this.onAddNewBoxClick}>
							<span className="plus">+</span>
							<h2>Add Letter</h2>
						</div>
						<div className="addNewBox" onClick={this.onAddNewTemplateBoxClick}>
							<span className="plus">+</span>
							<h2>Add Letter Template</h2>
						</div>
					</Row>
				</RenderIfUserHas>
				<Tabs
					onTabClick={this.onTabClick}
					selectedTab={this.state.selectedTab}
					tabs={["SENT", "RECEIVED", "TEMPLATES"]}
				/>
				{content.map(
					item =>
						item.type
							? this.renderLetter(item)
							: this.renderLetterTemplate(item)
				)}
			</Col>
		);
	}
}

const mapStateToProps = state => {
	return {
		letters: state.letter.all,
		letterTemplates: state.letterTemplate.all
	};
};

const mapDispatchToProps = {
	fetchLetters,
	deleteLetter,
	fetchLetterTemplates,
	deleteLetterTemplate
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LettersIndex);



// WEBPACK FOOTER //
// ./src/components/main/letters/index/LettersIndex.js